module.exports = __webpack_public_path__ + "media/images/social_svgs/facebook-547bb6a95d50814468b3346adc894c7b.svg";